import { memo, useState } from "react";
import { Icon, List, ListItem } from "semantic-ui-react";

// Interfaces
import { ICONS } from "./sequence/MeCast";

// Types
import { BroadcastAction } from "./MeCastType";

type BroadcastActionMenuProps = {
  actions: BroadcastAction[];
  onAction: (action: BroadcastAction) => void;
};

const ACTION_CONFIG: Record<BroadcastAction, { icon: React.ReactNode; label: string }> = {
  VIEW: { icon: <Icon name="eye" />, label: "View" },
  EDIT: { icon: <Icon name="edit" />, label: "Edit" },
  DUPLICATE: { icon: <Icon name="clone outline" />, label: "Duplicate" },
  CANCEL: { icon: <Icon name="cancel" />, label: "Cancel" },
  CANCEL_REVIEW: {
    icon: <img src={ICONS.cancelReview} style={{ width: "24px", height: "18px" }} alt="Cancel Review" />,
    label: "Cancel Review Process",
  },
};

const BroadcastActionMenu = (props: BroadcastActionMenuProps) => {
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  return (
    <List
      divided
      relaxed
      style={{
        position: "absolute",
        right: "40px",
        background: "white",
        border: "solid 1px #ccc",
        borderRadius: "4px",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
        zIndex: 10,
        fontSize: "1.2rem",
        fontWeight: "normal",
        padding: "0.5rem",
        margin: 0,
      }}
    >
      {props.actions.map((action, idx) => {
        const config = ACTION_CONFIG[action];

        return (
          <ListItem
            key={action}
            onClick={() => props.onAction(action)}
            onMouseEnter={() => setHoverIndex(idx)}
            onMouseLeave={() => setHoverIndex(null)}
            style={{
              backgroundColor: hoverIndex === idx ? "rgba(0, 0, 0, 0.1)" : "transparent",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "0.5rem",
                minWidth: "15rem",
                width: "100%",
                padding: "2px 0",
              }}
            >
              {config.icon}
              <label style={{ cursor: "pointer" }}>{config.label}</label>
            </div>
          </ListItem>
        );
      })}
    </List>
  );
};

export default memo(BroadcastActionMenu);
